import { BlockStack, InlineStack, Modal, TextField, Button, Form, InlineError } from '@shopify/polaris';
import __ from 'languages/index';
import { useCallback, useState } from 'react';
import { ViewIcon, HideIcon } from '@shopify/polaris-icons';
import helpers from 'helpers/index';
import { useSignByPassword } from 'queries/user.query';

/**
 * Xác thực hai bước, quan trọng!
 */
export default function UserSignComponent({ show = false, onClose }: { show: boolean; onClose: () => void }) {
  const { mutateAsync: signByPassword } = useSignByPassword();

  const [viewPasswordMode, setViewPasswordMode] = useState(false);
  const [textFieldValue, setTextFieldValue] = useState('');
  const hideModal = useCallback(async () => {
    onClose();
  }, []);

  const handleTextFieldChange = useCallback((value: string) => {
    setTextFieldValue(value);
  }, []);
  const [passwordFieldMeetError, setPasswordFieldMeetError] = useState(false);

  const [passwordChecking, setPasswordChecking] = useState(false);

  const signByPasswordCallback = useCallback(async () => {
    setPasswordChecking(true);
    setPasswordFieldMeetError(false);
    try {
      let data = await signByPassword(textFieldValue);
      helpers.cookie_set('XS', data.ATSL, 0.0833); // lưu lâu lâu chút, vì dù gì cũng là server quyết định ... 5 phút
      hideModal();
    } catch (e) {
      setPasswordFieldMeetError(true);
    } finally {
      setPasswordChecking(false);
    }
  }, [signByPassword, textFieldValue, hideModal]);

  return (
    <>
      <Modal
        activator={null}
        open={show}
        onClose={hideModal}
        title={__('you_must_signed_before_process')}
        primaryAction={{
          content: __('close'),
          onAction: hideModal,
        }}
      >
        <Modal.Section>
          <>
              <Form onSubmit={signByPasswordCallback}>
                <BlockStack gap="400">
                  <br />
                  <TextField
                    label={__('login_by_your_password')}
                    placeholder="******"
                    error={passwordFieldMeetError}
                    focused={passwordFieldMeetError}
                    type={viewPasswordMode ? 'text' : 'password'}
                    autoComplete="off"
                    suffix={
                      <InlineStack blockAlign="center">
                        <Button
                          variant="plain"
                          onClick={() => setViewPasswordMode(!viewPasswordMode)}
                          icon={viewPasswordMode ? ViewIcon : HideIcon}
                        ></Button>
                      </InlineStack>
                    }
                    value={textFieldValue}
                    onChange={handleTextFieldChange}
                    monospaced
                  />
                  <Button onClick={signByPasswordCallback} loading={passwordChecking}>
                    Xác thực
                  </Button>
                </BlockStack>
              </Form>
            </>

          <br />
          <InlineError
            message="Vui lòng cần cung cấp mật khẩu tài khoản admin hiện đang sử dụng để xác thực. Việc này bảo vệ an toàn cho hệ thống. Mỗi một phiên ký sẽ có giá trị trong vòng 5 phút."
            fieldID="some_f_id"
          />
        </Modal.Section>
      </Modal>
    </>
  );
}
